// extracted by mini-css-extract-plugin
export var altaccent = "ImageContent-module--altaccent--7db43";
export var bottomAlign = "ImageContent-module--bottom--align--007b2";
export var box = "ImageContent-module--box--32518";
export var content = "ImageContent-module--content--202e8";
export var image = "ImageContent-module--image--0fd9c";
export var ltr = "ImageContent-module--ltr--210f5";
export var rtl = "ImageContent-module--rtl--8d623";
export var topAlign = "ImageContent-module--top--align--d87fb";
export var visual = "ImageContent-module--visual--ad13b";